import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as usersActions from '../../redux/actions/usersActions';

import CheckboxIcon from '../icons/CheckboxIcon';
import InputErrors from '../common/InputErrors';
import KeyError from '../common/KeyError';

class WelcomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password1: '',
      password2: '',
      staySignedIn: false,
      passwordsMatchError: false,
      noPassword1Error: false,
      noPassword2Error: false,
      serverErrors: [],
      onloadErrors: [],
      keyValidated: false,
    };
  }

  login = (e) => {
    e.preventDefault();
    this.resetErrors();
    if (!this.state.password1) {
      this.setState({ noPassword1Error: true });
    } else if (!this.state.password2) {
      this.setState({ noPassword2Error: true });
    } else if (this.state.password1 !== this.state.password2) {
      this.setState({ passwordsMatchError: true });
    } else {
      this.props.dispatchUsersActions.welcome({
        userKey: this.props.location.search.substring(1), // remove leading '?'
        password: this.state.password1,
        staySignedIn: this.state.staySignedIn
      }, this.onFail);
    }
  }

  resetErrors = () => {
    this.setState({
      passwordsMatchError: false,
      noPassword1Error: false,
      noPassword2Error: false,
      serverErrors: []
    })
  }

  componentDidMount() {
    if (this.props.location.search.length) {
      this.props.dispatchUsersActions.getWelcomeData(
        this.props.location.search.substring(1), // remove leading '?'
        this.onOnloadSuccess,
        this.onOnloadFail
      );
    }
  }

  onOnloadSuccess = (userData) => {
    // Allow the page to continue loading
    this.setState({
      firstName: userData.firstName,
      lastName: userData.lastName,
      onloadErrors: [],
      keyValidated: true,
    });
  }

  onOnloadFail = (error) => {
    // Display the onload error state
    this.setState({
      onloadErrors: error.response
        ? error.response.data
        : ['There was a server error with your key.'],
      keyValidated: true,
    });
  }

  onFail = (error) => {
    // TO DO: Show errors in form
    // fail to validate password
    this.setState({
      serverErrors: error.response
        ? error.response.data
        : ['There was a problem connecting to the server.'],
    });
  }

  handleInputChange = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({ [name]: value });
  }

  render() {
    // Aggregate error messages
    let errors = this.state.serverErrors;
    if (this.state.noPassword1Error || this.state.noPassword2Error) {
      errors = [...errors, 'All fields are required.'];
    }
    if (this.state.passwordsMatchError) {
      errors = [...errors, 'Your new passwords must match.'];
    }

    // Wait for database response
    if (!this.state.keyValidated) {
      return null; // TO DO: add loading state
    }
    // Handle a bad key
    if (this.state.onloadErrors.length) {
      return <KeyError />;
    }
    // Jump out if there's no user key in the query params
    if (!this.props.location.search.length) return <Redirect to="/" />;
    // TO DO: Probably add in a loading state while waiting for the database to respond
    return this.props.loggedIn ? (
      // After login, redirect to the dashboard
      <Redirect to="/" />
    ) : (
      <Fragment>
        <Helmet>
          <title>Welcome</title>
        </Helmet>
        <div className="fullscreen-form fullscreen-form--muted">
          <div className="row fullscreen-form__content">
            <h1 className="fullscreen-form__heading">
              Welcome, {this.state.firstName} {this.state.lastName}
            </h1>
            <div className="fullscreen-form__subheading">
              Your email has been confirmed and your account has been created. Please create a password for your account.
            </div>
            <form className="form fullscreen-form__form">
              {errors.length !== 0 &&
                <InputErrors errors={errors} />
              }
              <label htmlFor="password1">
                Password
              </label>
              <input
                name="password1"
                id="password1"
                value={this.state.password1}
                onChange={this.handleInputChange}
                type="password"
              />
              <label htmlFor="password2">
                Confirm Password
              </label>
              <input
                name="password2"
                id="password2"
                value={this.state.password2}
                onChange={this.handleInputChange}
                type="password"
              />
              <div className="fullscreen-form__options">
                <div />
                <label className="fullscreen-form__checkbox">
                  <input
                    name="staySignedIn"
                    type="checkbox"
                    value={this.state.staySignedIn}
                    onChange={this.handleInputChange}
                  />
                  <CheckboxIcon value={this.state.staySignedIn} />
                  Stay signed in
                </label>
              </div>
              <div className="fullscreen-form__button-wrapper">
                <button
                  type="submit"
                  className="button button--large"
                  onClick={this.login}
                >
                  Log In
                </button>
              </div>
            </form>
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return { loggedIn: state.users.currentUserId && sessionStorage.jwt };
}

function mapDispatchToProps(dispatch) {
  return { dispatchUsersActions: bindActionCreators(usersActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WelcomePage);



// WEBPACK FOOTER //
// ./src/components/pages/WelcomePage.js